import { Box, styled } from "@mui/material";
import { Button } from "@pmag/ui-components";

export const Root = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(6),
    [theme.breakpoints.up("sm")]: {
        paddingTop: theme.spacing(8),
    },
}));

interface TopContainerProps {
    showBorderBottom?: boolean;
}

export const TopContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "showBorderBottom",
})<TopContainerProps>(({ theme, showBorderBottom }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(6),
    ...(showBorderBottom && { borderBottom: `1px solid ${theme.palette.core.grey._20}` }),

    [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(8),
        borderBottom: "unset",
    },
}));

export const NavigationButton = styled(Button)(({ theme }) => ({
    paddingTop: 0,
    paddingLeft: 0,
}));
